<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important">
  <span>{{ 'title.sign_list' | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>

<ng-container *ngIf="notifyWarning">
  <div class="mt-3">
    <span>
      <em [innerHTML]="notifyWarning" class="cl-e03"></em>
    </span>
  </div>
</ng-container>
<div class="row pb-2 py-3">
  <div class="col-12">
    <span>{{'search_form.sign_batch' | translate}}</span>
    <span style="color: #fc1203;">{{contracts.length}}</span>
    <span>{{'search_form.sign_batch_contracts' | translate}}</span>
    <span *ngIf="noOfFiles > 0">
      <span style="color: #fc1203;">{{noOfFiles}}</span>
      <span>{{'search_form.sign_batch_files' | translate}}</span>
    </span>
  </div>
</div>

<mat-dialog-content class="table-container example-container" style="max-height: 300px">
  <mat-table [dataSource]="contracts">
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        {{i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="width: 30%;"
                       class="mat-cell-non-boder-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{element.contractNameCode ? element.contractNameCode : (element.name ? element.name : element.contractName)}}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom" style="width: 30%;">
        <span class="fix-width">{{element.contractNameCode ? element.contractNameCode : (element.name ? element.name : element.contractName)}}</span>
      </mat-cell>
    </ng-container>

    <!-- Bên lập Column -->
    <ng-container matColumnDef="createdEnterpriseName">
      <mat-header-cell *matHeaderCellDef style="width: 25%;"
                       class="mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.created_enterprise' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.createdEnterpriseName }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                style="width: 25%;">
        <span class="fix-width">{{ element.createdEnterpriseName }}</span>
      </mat-cell>
    </ng-container>

    <!-- Ngày nhận Column -->
    <ng-container matColumnDef="receivedTime">
      <mat-header-cell *matHeaderCellDef
                       class="mat-cell-non-boder-right-bottom" style="width: 15%;">
        {{'headertable.received_time' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                class="mat-cell-non-boder-right-bottom" style="width: 15%;">
        <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
  </mat-table>
</mat-dialog-content>
<mat-divider class="mt-2"></mat-divider>

<mat-dialog-actions align="center" class="action">
  <button mat-stroked-button color="primary" class="mr-3" (click)="onCancel()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.cancel' | translate}}
  </button>
  <button mat-raised-button color="primary" (click)="onContinue()" type="button">
    <mat-icon class="mr-0">arrow_forward</mat-icon>
    {{'button.continue' | translate}}
  </button>
</mat-dialog-actions>
